module.exports = __webpack_public_path__ + "components/flag/static/square/gf-8a954ba5d7af20096f5bdda56f3837ad.svg";